import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useEffect } from "react";
import { useState } from "react";
import Layout from "../components/Layout";
import fireDB from "../fireconfig";

import "../assets/css/Orders.scss";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const result = await getDocs(
        query(
          collection(fireDB, "orders"),
          where(
            "userId",
            "==",
            `${JSON.parse(localStorage.getItem("currentUser")).user.uid}`
          )
        )
      );
      const ordersArray = [];
      result.forEach((doc) => {
        ordersArray.push(doc.data());
      });
      setLoading(false);
      setOrders(ordersArray);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <Layout loading={loading}>
      <h1>Orders</h1>
      {orders.map((order) => {
        return (
          <table className="table orders_table" key={order.total}>
            <thead>
              <tr>
                <th scope="col">Image</th>
                <th scope="col">Name</th>
                <th scope="col" className="text-center">
                  Price
                </th>
              </tr>
            </thead>
            <tbody>
              {order.cartItems.map((item) => {
                return (
                  <tr key={item.title}>
                    <td>
                      <img
                        src={item.image}
                        alt={item.title}
                        height="150"
                        width="225"
                      />
                    </td>
                    <td>
                      <p>{item.title}</p>
                      <p className="cart-item-description">
                        {item.description}
                      </p>
                    </td>
                    <td className="text-center">{item.price}/-</td>
                  </tr>
                );
              })}
              <tr className="order_total_row">
                <td colSpan="2">Total :</td>
                <td>{order.total}/-</td>
              </tr>
            </tbody>
          </table>
        );
      })}
    </Layout>
  );
};

export default Orders;
